import { colmarLogoBase64 } from 'assets/colmarLogoBase64';

import { SkeletonBlock } from 'components/Skeleton';

import * as S from './BudgetListSkeleton.styles';

type BudgetListSkeletonProps = {
  /** Placeholder rows to draw. */
  rows?: number;
  /** Product rows have an image; the Fabric / Marketing / Gender summary rows don't. */
  withImage?: boolean;
  /** Table columns of the row it stands for. */
  columns?: number;
};

/**
 * Loading placeholder of the budget detail lists — same layout as a
 * BudgetProduct row (expand button, image, header + value line) and the same
 * shimmer as the other skeleton loaders.
 */
export function BudgetListSkeleton({
  rows = 3,
  withImage = true,
  columns = 8,
}: BudgetListSkeletonProps): React.ReactElement {
  return (
    <div aria-hidden="true" data-testid="budget-list-skeleton">
      {Array.from({ length: rows }, (_, row) => (
        <S.Row key={row} data-testid="budget-list-skeleton-row">
          <S.ButtonCell>
            <SkeletonBlock width="2rem" height="2rem" />
          </S.ButtonCell>

          {withImage ? (
            <S.ImageCell>
              <S.Logo src={colmarLogoBase64} alt="" />
            </S.ImageCell>
          ) : undefined}

          <S.TableCell>
            <S.Line columns={columns}>
              {Array.from({ length: columns }, (__, col) => (
                <SkeletonBlock key={col} width="70%" height="1.4rem" />
              ))}
            </S.Line>
            <S.Line columns={columns}>
              {Array.from({ length: columns }, (__, col) => (
                <SkeletonBlock key={col} width="50%" height="1.8rem" />
              ))}
            </S.Line>
          </S.TableCell>
        </S.Row>
      ))}
    </div>
  );
}
